import { Badge } from "@/components/ui/badge";
import {
  purchaseRequestStatusColor,
  purchaseRequestStatusLabel,
} from "@/constants/purchase-request";

interface StatusBadgeProps {
  status: string;
  className?: string;
  size?: "sm" | "md" | "lg";
}

export default function StatusBadge({ status, className = "", size = "md" }: StatusBadgeProps) {
  const color = purchaseRequestStatusColor(status) ?? "bg-muted text-foreground";
  const label = purchaseRequestStatusLabel(status);
  const sizeClasses = size === "lg" ? "text-sm px-3 py-1.5" : size === "sm" ? "text-[11px] px-2 py-0.5" : "text-xs px-2.5 py-1";

  return (
    <Badge className={`${color} ${sizeClasses} ${className}`}>{label}</Badge>
  );
}

